import XLSX from "xlsx";

export default function VoyageExportExcel(voyage_account) {
  let sheet_array = [];
  let header1 = new Array(11).fill("");
  header1[0] = "Comerge Shipping Company Ltd.";
  sheet_array.push(header1);

  let header2 = new Array(11).fill("");
  header2[0] = "ID:" + voyage_account.id;
  header2[1] = "MV:" + voyage_account.mv;
  sheet_array.push(header2);

  let header3 = new Array(11).fill("");
  header3[0] = "Charterer:" + voyage_account.charterer;
  header3[1] = "Charter Type:" + voyage_account.charter_type;
  header3[2] = "Leg:" + voyage_account.leg;
  header3[3] = "Voyage Year:" + voyage_account.voyage_year;
  sheet_array.push(header3);

  let header4 = new Array(11).fill("");
  header4[0] =
    "Delivery ~ Redelivery:" +
    voyage_account.delivery +
    "---" +
    voyage_account.redelivery;
  header4[1] =
    "Load Port ~ Disc. Port:" +
    voyage_account.load_port +
    "---" +
    voyage_account.disc_port;
  header4[2] = "BL Date:" + voyage_account.bl_date;
  header4[3] = "BL Quantity:" + voyage_account.bl_quantity;
  sheet_array.push(header4);

  let header5 = new Array(11).fill("");
  header5[0] =
    "LAYCAN:" + voyage_account.laycan[0] + "---" + voyage_account.laycan[1];
  header5[1] =
    "Chartering Period:" +
    voyage_account.period[0] +
    "---" +
    voyage_account.period[1];
  sheet_array.push(header5);

  let header6 = new Array(11).fill("");
  header6[0] =
    "Load Port Stay:" +
    voyage_account.load_port_stay[0] +
    "---" +
    voyage_account.load_port_stay[1];
  header6[1] =
    "Disc. Port Stay:" +
    voyage_account.disc_port_stay[0] +
    "---" +
    voyage_account.disc_port_stay[1];

  let worksheet = XLSX.utils.aoa_to_sheet(sheet_array);
  worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }];

  let workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, "hello_excel.xlsx");
}
